








import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'InputError',
  props: {
    error: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const onClick = () => {
      emit('click')
    }

    return {
      onClick,
    }
  },
})
